module.exports = __webpack_public_path__ + "img/dev-heroes-2.a50a0185.jpg";